import { AfterViewInit, ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { PromptExample } from '@shared/models';
import { ChatService } from '../chat.service';
import { PromptExampleIconComponent } from './prompt-example-icon';

@Component({
  selector: 'mai-prompt-examples-dropdown',
  imports: [PromptExampleIconComponent],
  templateUrl: './prompt-examples-dropdown.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PromptExamplesDropdown implements AfterViewInit {
  private readonly service = inject(ChatService);

  readonly promptExamples = this.service.promptExamples;

  // First paint, overlay is hidden
  readonly transitionClasses = signal('not-expanded:translate-y-full opacity-0');

  ngAfterViewInit(): void {
    // second frame, animated in
    requestAnimationFrame(() => this.transitionClasses.set('transition-all duration-300'));
  }

  selectPrompt(example: PromptExample) {
    this.service.selectPromptExample(example);
  }
}
